import { __extends } from "tslib";
/**
 * Created by Created by Olga.Szczepaniak on 2016-11-17.
 * https://confluence.makolab.net/display/BSS/04.01.01.09.01.26+BSS+Table+Component#id-04.01.01.09.01.26BSSTableComponent-RemoteUpdateInputData
 */
import BSSAbstractComponent from '../../bss-abstract-component/js/bss-abstract-component.js';
import template from '../template/simple-table.hbs';
import twoColumnsTableTemplate from '../template/two-columns-table.hbs';
import logger from '@main/externals/bss-package-logger/js/logger';
var templateObject = {
    defaultTemplate: template,
    twoColumnsTableTemplate: twoColumnsTableTemplate,
};
/**
 * BSSTableComponent class
 */
var BSSTableComponent = /** @class */ (function (_super) {
    __extends(BSSTableComponent, _super);
    /**
     * @desc BSSTableComponent constructor - generates all necessary objects and initialize slider
     * @param {Object} [_entityTemplate=null] - simulator template
     * @param {String} [containerSelector=null] - component container selector
     * @param {Object} [config=null] - configuration of comonent
     * @param {EventManager} [eventManager=null] - instance of EventManager
     * @param {Formatter} [formatter=null] - instance of Formatter
     * @param {Resolution} [resolution=null] - device Resolution
     * @param {Object} [toolbox=null] - provides common libraries: jquery and lodash
     * @listens {bss-table-component-$COMPONENT-ID-refresh} listen event because table should be re-rendered with income data
     */
    function BSSTableComponent(_entityTemplate, containerSelector, config, eventManager, formatter, resolution, toolbox) {
        if (_entityTemplate === void 0) { _entityTemplate = null; }
        if (containerSelector === void 0) { containerSelector = null; }
        if (config === void 0) { config = null; }
        if (eventManager === void 0) { eventManager = null; }
        if (formatter === void 0) { formatter = null; }
        if (resolution === void 0) { resolution = null; }
        if (toolbox === void 0) { toolbox = null; }
        var _this = _super.call(this, _entityTemplate, containerSelector, config, eventManager, formatter, resolution, templateObject, toolbox) || this;
        _this._componentVersion = '@@name ver. @@version';
        logger.info('TableComponent:  => constructor : componentId: ' +
            config.componentId +
            ' | Params: ', _entityTemplate, containerSelector, config, eventManager, formatter, resolution, templateObject, logger, toolbox);
        if (_this._config.remoteUpdate) {
            _this._eventManager.subscribe('bss-table-component-' + _this._config.componentId + '-refresh', _this._remoteUpdate.bind(_this), _this.subscriberPrefix + _this._config.componentId);
        }
        return _this;
    }
    /**
     * @desc prepare data for hbs, when remoteUpdate is set true, regular update after response from server is switched off (isUpdateSubscriptionOff is set true)
     * @override
     * @private
     */
    BSSTableComponent.prototype._prepareData = function () {
        logger.info('TableComponent: ' +
            this._config.componentId +
            ' => function : _prepareData');
        //when remoteUpdate is set true, regular update after response from server is switched off (isUpdateSubscriptionOff is set true)
        if (this._config.remoteUpdate) {
            this.isUpdateSubscriptionOff = true;
        }
        this._setTableHeaders(this._config.headers);
        this._setTableData(this._config.data);
        this._fixData(this._config.headers, this._config.tableData);
    };
    /**
     * @desc creates data object, we assign data from texts to key depends on binding definition from dataObj
     * @param {Object} bindDef
     * @private
     */
    BSSTableComponent.prototype._setTableData = function (bindDef) {
        logger.info('TableComponent: ' +
            this._config.componentId +
            ' => function : _setTableData | Param ', bindDef);
        this._config.tableData = this._getValue(bindDef);
    };
    /**
     * @desc creates header object, we assign data from texts to key depends on binding definition from headerObj
     * @param {Object} bindDef
     * @private
     */
    BSSTableComponent.prototype._setTableHeaders = function (bindDef) {
        var _this = this;
        logger.info('TableComponent: ' +
            this._config.componentId +
            ' => function : _setTableHeaders | Param ', bindDef);
        this._config.tableHeaders = {};
        this._toolbox._.each(bindDef, function (v, k) {
            _this._config.tableHeaders[k] = _this._getBoundedString(v)
                ? _this._getBoundedString(v)
                : '  ';
        });
    };
    /**
     * @desc rebind data after response, custom because we have to re-render component html: tabel data can have different size
     * @param {String} publisherName - event owner name
     * @param {Object} updateMap - holds new text and dataResult
     * @emits {bss-component-data-rebound-$COMPONENT-ID} emit eventt when table is re-rendered
     * @override
     * @private
     */
    BSSTableComponent.prototype.update = function (publisherName, updateMap) {
        logger.info('TableComponent: ' +
            this._config.componentId +
            ' => function : _update | Param ', publisherName, updateMap);
        // save update timestap - for component-critical-error handling
        this._lastUpdateTimestamp = updateMap.updateTimestamp;
        // if there is regular update event (not revert state) and critical error was thrown, do not update this component!
        if (this._stopUpdateFlag && !this._isRevertStateEvent) {
            this._stopUpdateFlag = false;
            if (typeof data.resultData[this._config.productId[0]].error_code !==
                'undefined') {
                this.setErrorObject({
                    errorMsg: 'config -> there is no complete set of data',
                    errorSeverity: 'critical',
                });
                this._onCriticalError(this._errorObj);
            }
            return;
        }
        this._resetErrorObject();
        this._validateDataOnChange(updateMap);
        if (this._toolbox._.has(updateMap, 'texts')) {
            this._setTableHeaders(this._config.headers);
        }
        if (this._toolbox._.has(updateMap, 'resultData')) {
            this._setTableData(this._config.data);
        }
        this._fixData(this._config.headers, this._config.tableData);
        this._refreshTemplate();
        this._resetValueTags(this._toolbox._.has(updateMap, 'texts'));
        this._bindData(updateMap);
        this._eventManager.publish('bss-component-data-rebound-' + this._config.componentId, this._config.componentType + '-' + this._config.componentId, updateMap);
        this._isRevertStateEvent = false;
    };
    /**
     * @desc method refresh template, removes old one from DOM and add new.
     * @private
     */
    BSSTableComponent.prototype._refreshTemplate = function () {
        logger.info('TableComponent: ' +
            this._config.componentId +
            ' => function : _refreshTemplate');
        //we have to remove html
        this._componentTemplate.remove();
        this._setComponentTemplate(templateObject);
        if (this._containerSelector == null) {
            this._entityTemplate.append(this._componentTemplate);
        }
        else {
            this._entityTemplate
                .find(this._containerSelector)
                .append(this._componentTemplate);
        }
        this._componentScope = this._componentTemplate;
    };
    /**
     * @desc trigger re-render table with new data
     * @param {String} publisherName - event owner name
     * @param {Object} data - holds new text and dataResult
     * @emits {bss-table-component-$COMPONENT-ID-updated} emit eventt when table is re-rendered
     * @private
     */
    BSSTableComponent.prototype._remoteUpdate = function (publisherName, data) {
        logger.info('TableComponent: ' +
            this._config.componentId +
            ' => function : _remoteUpdate | Param ', publisherName, data);
        this._resetErrorObject();
        this._setTableData(data);
        this._fixData(this._config.headers, this._config.tableData);
        this._refreshTemplate();
        this._eventManager.publish('bss-table-component-' + this._config.componentId + '-updated', this._config.componentId);
    };
    /**
     * @desc fills data to have the same number of td as number of headers
     * @param {Object} headers
     * @param {Array<Object>} data
     * @private
     */
    BSSTableComponent.prototype._fixData = function (headers, data) {
        var _this = this;
        logger.info('TableComponent: ' +
            this._config.componentId +
            ' => function : _fixData | Param ', headers, data);
        if (this._config.componentTemplate === 'twoColumnsTableTemplate') {
            return;
        }
        var _loop_1 = function (i, len) {
            this_1._toolbox._.forIn(headers, function (v, k) {
                if (!_this._toolbox._.has(data[i], k)) {
                    data[i][k] = '  ';
                }
            });
        };
        var this_1 = this;
        for (var i = 0, len = data.length; i < len; i++) {
            _loop_1(i, len);
        }
    };
    /**
     * @desc validate component - in this component this._rebindData(updateMap) was removed; rebind is done after refreshTemplate
     * @param {Object} updateMap - new component data (dataResult or Texts)
     * @param {Boolean} [isDataToBind=true] isDataToBind - if set to true update config and rebind data
     * @override
     * @private
     */
    BSSTableComponent.prototype._validateDataOnChange = function (updateMap, isDataToBind) {
        if (isDataToBind === void 0) { isDataToBind = true; }
        logger.info('AbstractComponent: ' +
            this._config.componentId +
            ' => function : _validateDataOnChange' +
            ' | Params: ', updateMap, isDataToBind);
        switch (this._errorType) {
            case null:
                if (isDataToBind) {
                    this._updateConfig(updateMap);
                }
                break;
            case 'minor':
                this.onMinorError(this._errorObj);
                break;
            case 'critical':
                this._onCriticalError(this._errorObj);
                break;
        }
    };
    return BSSTableComponent;
}(BSSAbstractComponent));
export default BSSTableComponent;
